const initialState = {myassignments: []}
const initialStateNew = {myCurrentRunningAssignments: []}

export const myassignments = (state = initialState, action) => {
	switch (action.type) {
  	case 'SET_MYASSIGNMENTS':
      return {myassignments: action.payload}; 
  }
  return state
}

export const myCurrentRunningAssignments = (state = initialStateNew, action) => {
	switch (action.type) {
  	case 'SET_MY_CURRENT_ASSIGNMENTS':
      return {myCurrentRunningAssignments: action.payload}; 
  }
  return state
}


